import React, { Component } from "react";

class CustomSelect extends Component {
    state = {
        selectedOption: null,
        isOpen: false,
    };

    toggleDropdown = () => {
        this.setState((prevState) => ({ isOpen: !prevState.isOpen }));
    };

    selectOption = (option) => {
        this.setState({ selectedOption: option, isOpen: false });

        this.props.onSelectOptionChange(option.id)
    };

    render() {
        const { options } = this.props;
        const { selectedOption, isOpen } = this.state;

        return (
            <div className="custom-select form-select">
                {/* Selected Option */}
                <div className="select-box p-0" onClick={this.toggleDropdown}>
                    {selectedOption ? (
                        <div>
                            <strong>{selectedOption.title}</strong>
                            <div className="subtext">{selectedOption.subtitle}</div>
                        </div>
                    ) : <div className="empty-option">{this.props.emptyItemText !== undefined ? this.props.emptyItemText : "-----"}</div>}
                </div>

                {/* Dropdown Options */}
                {isOpen && (
                    <div className="dropdown" style={{zIndex: 1052}}>
                        {options.map((option, index) => (
                            <div
                                key={index}
                                className="option"
                                onClick={() => this.selectOption(option)}
                            >
                                <strong>{option.title}</strong>
                                <div className="subtext">{option.subtitle}</div>
                            </div>
                        ))}
                    </div>
                )}
            </div>
        );
    }
}

export default CustomSelect;
